import SEO from '../components/SEO/SEO'
import Contact from '../components/Contact/Contact'

export default function ContactPage() {
  return (
    <>
      <SEO
        title="Tattoo Enquiries Adelaide | Jesse B Tattoos"
        description="Send a tattoo enquiry to Jesse B Tattoos in Adelaide. Upload reference images, describe your idea, and receive a response within 2 business days."
        canonical="https://jessebtattoos.com/contact"
        keywords="tattoo enquiry Adelaide, Jesse B Tattoos contact, custom tattoo enquiry, tattoo consultation Adelaide"
        ogType="website"
      />
      <Contact />
    </>
  )
}